module.exports = __webpack_public_path__ + "static/media/anatomia.8ed06fae.png";